var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.form)?_c('resource-form',{attrs:{"model":_vm.form.model,"schema":_vm.form.schema,"triggers":_vm.form.triggers},on:{"submit":_vm.handle_submit}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("\n      Annuler\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32da471b","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/CRM/LeadItemAddition.vue
// module id = 1806
// module chunks = 0